import { request } from "../libs";

export default (serverUrl) => {
	return request(
		`${serverUrl}/search-list`,
		{
			method: "GET"
		}
	)
		.then(response => response.json());
};
